
<div class="max-w-[968px] mx-auto mt-16 md:mt-48 px-16 pb-72 md:pb-0">
  <provider-profile-action-bar
    :accountTypeInfo="accountTypeInfo"
    :profileAccountData="profileAccountData"
    :viewerAccountData="viewerAccountData"
    :favoritedSitter="favoritedSitter"
    @favoritedSitterChange="favoritedSitterChange"
  />
  <provider-profile-loading-skeleton v-if="loading" />
  <provider-profile-error-skeleton v-else-if="bannerType === BannerType.ACCOUNT_NOT_FOUND" />
  <div v-else class="flex flex-col gap-16 mt-24 md-1:flex-row md-1:gap-32">
    <div class="w-full top-128 self-start md-1:max-w-[45%] md-1:sticky">
      <provider-profile-sitter-snapshot
        :profileAccountData="profileAccountData"
        :profileBelongsToViewer="profileBelongsToViewer"
        :iconListItems="snapshotIconListItems"
        :rateDisplay="rateDisplay"
        :accountTypeInfo="accountTypeInfo"
        :favoritedSitter="favoritedSitter"
        @favoritedSitterChange="favoritedSitterChange"
        @item-click="(item) => item.clickHandler()"
      />
    </div>
    <provider-profile-sections
      class="w-full md-1:max-w-[55%] mb-[160px] md-1:mb-0"
      :profileAccountData="profileAccountData"
      :paramData="paramData"
    />
  </div>
</div>
